export const item = {
  REQUEST: 'AssignmentServiceRequest/Item/Request',
  SUCCESS: 'AssignmentServiceRequest/Item/Success',
  FAILURE: 'AssignmentServiceRequest/Item/Failure'
};

export const split = {
  REQUEST: 'AssignmentServiceRequest/Split/Request',
  SUCCESS: 'AssignmentServiceRequest/Split/Success',
  FAILURE: 'AssignmentServiceRequest/Split/Failure'
};

export const SPLITTED_RESEND = {
  REQUEST: 'AssignmentServiceRequest/SplitResend/Request',
  SUCCESS: 'AssignmentServiceRequest/SplitResend/Success',
  FAILURE: 'AssignmentServiceRequest/SplitResend/Failure'
};

export const RESPONSE_SUGGESTION = {
  REQUEST: 'AssignmentServiceRequest/ResponseSuggestion/Request',
  SUCCESS: 'AssignmentServiceRequest/ResponseSuggestion/Success',
  FAILURE: 'AssignmentServiceRequest/ResponseSuggestion/Failure'
};

export const splitAndSend = {
  REQUEST: 'AssignmentServiceRequest/SplitAndSend/Request',
  SUCCESS: 'AssignmentServiceRequest/SplitAndSend/Success',
  FAILURE: 'AssignmentServiceRequest/SplitAndSend/Failure'
};

export const undo = {
  REQUEST: 'AssignmentServiceRequest/Split/Undo/Request',
  SUCCESS: 'AssignmentServiceRequest/Split/Undo/Success',
  FAILURE: 'AssignmentServiceRequest/Split/Undo/Failure'
};

export const remove = {
  REQUEST: 'AssignmentServiceRequest/Split/Undo/Request',
  SUCCESS: 'AssignmentServiceRequest/Split/Undo/Success',
  FAILURE: 'AssignmentServiceRequest/Split/Undo/Failure'
};

export const updateResponse = {
  REQUEST: 'AssignmentServiceRequest/Split/Undo/Request',
  SUCCESS: 'AssignmentServiceRequest/Split/Undo/Success',
  FAILURE: 'AssignmentServiceRequest/Split/Undo/Failure'
};
export const FORSUBMIT = {
  REQUEST: 'AssignmentServiceRequest/ForSubmit/Request',
  SUCCESS: 'AssignmentServiceRequest/ForSubmit/Success',
  FAILURE: 'AssignmentServiceRequest/ForSubmit/Failure'
};
export const UPDATESPLITTED = {
  REQUEST: 'AssignmentServiceRequest/Update/Splitted/Request',
  SUCCESS: 'AssignmentServiceRequest/Update/Splitted/Success',
  FAILURE: 'AssignmentServiceRequest/Update/Splitted/Failure'
};

export const CLEAR = {
  REQUEST: 'AssignmentServiceRequest/Clear/Request',
  SUCCESS: 'AssignmentServiceRequest/Clear/Success',
  FAILURE: 'AssignmentServiceRequest/Clear/Failure'
};

export const BULK_ASSIGN = {
  REQUEST: 'AssignmentServiceRequest/BulkAssignment/Request',
  SUCCESS: 'AssignmentServiceRequest/BulkAssignment/Success',
  FAILURE: 'AssignmentServiceRequest/BulkAssignment/Failure'
};

export const BULK_APPOINT = {
  REQUEST: 'AssignmentServiceRequest/BulkAppointment/Request',
  SUCCESS: 'AssignmentServiceRequest/BulkAppointment/Success',
  FAILURE: 'AssignmentServiceRequest/BulkAppointment/Failure'
};

export const CAN_BULK_ASSIGN = {
  REQUEST: 'AssignmentServiceRequest/CanBulkAssign/Request',
  SUCCESS: 'AssignmentServiceRequest/CanBulkAssign/Success',
  FAILURE: 'AssignmentServiceRequest/CanBulkAssign/Failure'
};
export const BULK_ASSIGN_FORSUBMIT = {
  REQUEST: 'AssignmentServiceRequest/BulkAssignment/ForSubmit/Request',
  SUCCESS: 'AssignmentServiceRequest/BulkAssignment/ForSubmit/Success',
  FAILURE: 'AssignmentServiceRequest/BulkAssignment/ForSubmit/Failure'
};
export const UPDATERESPONSESHAREDCOST = {
  REQUEST: 'AssignmentServiceRequest/Response/IsSharedCost/Request',
  SUCCESS: 'AssignmentServiceRequest/Response/IsSharedCost/Success',
  FAILURE: 'AssignmentServiceRequest/Response/IsSharedCost/Failure'
};
export const UPDATERESPONSE_IS_EARLY_CONFIRMATION_REQUIRED = {
  REQUEST: 'AssignmentServiceRequest/Response/IsEarlyConfirmationRequired/Request',
  SUCCESS: 'AssignmentServiceRequest/Response/IsEarlyConfirmationRequired/Success',
  FAILURE: 'AssignmentServiceRequest/Response/IsEarlyConfirmationRequired/Failure'
}
export const GETANNEXFILTEREDIDS = {
  REQUEST: 'AssignmentServiceRequest/GetAnnexFilteredIds/Request',
  SUCCESS: 'AssignmentServiceRequest/GetAnnexFilteredIds/Success',
  FAILURE: 'AssignmentServiceRequest/GetAnnexFilteredIds/Failure'
};
export const UPDATE_ASSIGNMENT_DELIVERY = {
  REQUEST: 'AssignmentServiceRequest/UpdaetAssignmentDelivery/Request',
  SUCCESS: 'AssignmentServiceRequest/UpdaetAssignmentDelivery/Success',
  FAILURE: 'AssignmentServiceRequest/UpdaetAssignmentDelivery/Failure'
};
export const ROLLBACK_DELIVERY = {
  REQUEST: 'AssignmentServiceRequest/RollbackDelivery/Request',
  SUCCESS: 'AssignmentServiceRequest/RollbackDelivery/Success',
  FAILURE: 'AssignmentServiceRequest/RollbackDelivery/Failure'
};
export const APPOINTMENT = {
  REQUEST: 'AssignmentServiceRequest/Appointment/Request',
  SUCCESS: 'AssignmentServiceRequest/Appointment/Success',
  FAILURE: 'AssignmentServiceRequest/Appointment/Failure'
};

export const REMOVE_APPOINTMENT = {
  REQUEST: 'AssignmentServiceRequest/RemoveAppointment/Request',
  SUCCESS: 'AssignmentServiceRequest/RemoveAppointment/Success',
  FAILURE: 'AssignmentServiceRequest/RemoveAppointment/Failure'
};
export const UPDATE_ASSIGNMENT_DELIVERY_FINILIZED = {
  REQUEST:
    'AssignmentServiceRequest/UpdaetAssignmentDeliveryFinalizedStatus/Request',
  SUCCESS:
    'AssignmentServiceRequest/UpdaetAssignmentDeliveryFinalizedStatus/Success',
  FAILURE:
    'AssignmentServiceRequest/UpdaetAssignmentDeliveryFinalizedStatus/Failure'
};
